// Turns a YouTube or Facebook video link into an embeddable player URL. Returns "" for anything else.
export const embedUrl = (url = "") => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  if (/(facebook\.com|fb\.watch)\//.test(url)) return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`;
  return "";
};

export const youtubeThumb = (url = "") => {
  const m = embedUrl(url).match(/youtube\.com\/embed\/([\w-]{11})/);
  return m ? `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` : "";
};
